import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';
import { SectionBlock, Label, Typography } from '@oca/ui';
import { Trans } from '@lingui/macro';
import MiniCard from './mini-card';

export function ProfileBlock({ children, title, list, blockWidth }) {
  return (
    <SectionBlock title={title} className="content">
      <Flex flexWrap="wrap" style={{ gap: 12 }}>
        {list.map(({ label, value }, index) => (
          <MiniCard flex={1} key={index} width={blockWidth}>
            <Label fontSize={15} color="textSecondary" gutterBottom>
              {label}
            </Label>
            <Typography fontSize={16} fontWeight={500} variant="body2">
              {value || <Trans>Not specified</Trans>}
            </Typography>
          </MiniCard>
        ))}
      </Flex>
      {children}
    </SectionBlock>
  );
}

ProfileBlock.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    }),
  ),
  blockWidth: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
};

ProfileBlock.defaultProps = {
  children: null,
  title: null,
  list: [],
  blockWidth: [1 / 3, 1 / 4],
};
